import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import axios from "axios";
import "./prijava.css";

const PrijavaBezPl = () => {

  const [images, setImages] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    city: "",
    email: "",
    instagram: "",
    brand: "",
    model: "",
    year: "",
    plate: "",
    mods: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages((prev) => [...prev, ...files]);
  };

  const removeImage = (index) => {
    const updated = images.filter((_, i) => i !== index);
    setImages(updated);
  };

  // Upload slike na Cloudinary
  const uploadImagesToCloudinary = async () => {
    const urls = [];

    for (const image of images) {
      const data = new FormData();
      data.append("file", image);
      data.append("upload_preset", "mrle_garage");

      const res = await axios.post(
        "https://api.cloudinary.com/v1_1/dagotozry/image/upload",
        data
      );

      urls.push(res.data.secure_url);
    }

    return urls;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  // ✅ VALIDACIJA
  if (!formData.name) return setError("Ime je obavezno.");
  if (!formData.email) return setError("Email je obavezan.");
  if (!formData.phone) return setError("Telefon je obavezan.");
  if (images.length < 3) return setError("Dodaj barem 3 slike.");

  let urls = [];

  // ✅ 1. UPLOAD SLIKA
  try {
    urls = await uploadImagesToCloudinary();
    setImageUrls(urls);
  } catch (err) {
    console.error("UPLOAD ERROR:", err);

    if (err.message.includes("Network Error")) {
      return setError("Problem s internetom prilikom upload-a slika.");
    }

    if (err.response?.status === 400) {
      return setError("Neispravna slika ili upload nije dopušten.");
    }

    return setError("Greška pri uploadu slika. Pokušaj ponovno.");
  }

  // ✅ 2. PRIPREMA PODATAKA ZA EMAIL
  const templateParams = {
    ...formData
  };

  // dinamički dodaj slike
  urls.forEach((url, i) => {
    templateParams[`image${i + 1}`] = url;
  });

  // fallback za prazne slike (bitno za EmailJS template)
  for (let i = 1; i <= 9; i++) {
    if (!templateParams[`image${i}`]) {
      templateParams[`image${i}`] = "";
    }
  }

  // ✅ 3. SLANJE EMAILA
  try {
    await emailjs.send(
      "mrletest",
      "template_gkctg6q",
      templateParams,
      "xyQeKEtUSYSu2g5S2"
    );

    // success redirect
    window.location.href = "/zahvala";

  } catch (err) {
    console.error("EMAIL ERROR:", err);

    if (err.message.includes("Network Error")) {
      return setError("Problem s internetom prilikom slanja emaila.");
    }

    if (err.text) {
      return setError("Email servis greška: " + err.text);
    }

    return setError("Greška pri slanju prijave. Pokušaj ponovno.");
  }
};

  return (
    <div className="pocetna-container container mb-5">

      {error && <p style={{ color: "red" }}>{error}</p>}

      <form className="row g-3" onSubmit={handleSubmit}>

          {/* 👤 O tebi */}
        <div className="row">
          <h1>O tebi</h1>
          <p>Popuni podatke za prijavu:</p>
        </div>

    <div className="col-md-6">
          <label className="form-label">Ime i prezime</label>
            <input name="name" onChange={handleChange} className="form-control form-label" />
        </div>

        <div className="col-md-6">
          <label className="form-label">Broj mobitela</label>
        <input name="phone"  onChange={handleChange} className="form-control form-label" />
         </div>
         <div className="col-md-6">
          <label className="form-label">Grad</label>
        <input name="city"  onChange={handleChange} className="form-control form-label" />
        </div>

        <div className="col-md-6">
          <label className="form-label">E Mail adresa</label>
        <input name="email"  onChange={handleChange} className="form-control form-label" />

        </div>
        <div className="col-md-12">
          <label className="form-label">Instagram username</label>
        <input name="instagram"  onChange={handleChange} className="form-control form-label" />
        </div>

 {/* 🚗 O autu */}
        <div className="row mt-4">
          <h1>O autu</h1>
        </div>

      <div className="col-md-6">
          <label className="form-label">Marka auta</label>
        <input name="brand"  onChange={handleChange} className="form-control form-label" />
      </div>

      <div className="col-md-6">
          <label className="form-label">Model auta</label>
        <input name="model" onChange={handleChange} className="form-control form-label " />
      </div>

    <div className="col-md-12">
          <label className="form-label">Godina</label>
        <input name="year" onChange={handleChange} className="form-control form-label" />
      </div>
      <div className="col-md-12">
          <label className="form-label">Registarska oznaka</label>
        <input name="plate" onChange={handleChange} className="form-control form-label" />
        </div>

      <div className="col-md-12">
          <label className="form-label">Modifikacije</label>
               <textarea
                    name="mods"
                    onChange={handleChange}
                    className="form-control"
                    rows={6}
                  />
      </div>

      <div className="col-12">
          <label className="form-label">Slike auta (min. 3)</label>
        <input
          type="file"
          multiple
          accept="image/*"
          onChange={handleImageChange}
          className="form-control"
        />
    </div>

       
        <div className="image-preview">
          {images.map((img, index) => (
            <div className="image-box" key={index}>
              <img  src={URL.createObjectURL(img)}  alt="preview" height="100" />
              <button type="button" className="remove-btn" onClick={() => removeImage(index)}>
                ×
              </button>
            </div>
          ))}
        </div>

         <div className="col-12">
           <button type="submit" className="btn "disabled={loading}>
          {loading ? "Slanje prijave..." : "Prijavi se"}
        </button>
        </div>

      </form>
    </div>
  );
};

export default PrijavaBezPl;